import { Currency } from '@guestgoodie/pricing'

export const dateFormatter = new Intl.DateTimeFormat(undefined, {
  year: '2-digit',
  month: '2-digit',
  day: '2-digit',
  // We show all datetimes in UTC
  timeZone: 'UTC'
})

export function formatPrice(currency: Currency, price: number) {
  const priceFormatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency
  })

  return priceFormatter.format(price)
}
